import React from "react";
import Faq_header from "./header";
import Faq_questions from "./questions";

function Faq_content(){

    return(
        <div id="faq">
            <Faq_header />
            <Faq_questions />
        </div>
    );

}

export default Faq_content;